<dx-validation-group *adaptLoading="!person">
    @if (person) {
        <div class="mx-3">
            <div class="form-group">
                <label for="personImage">Set your profile picture</label>
                <adapt-select-image id="personImage"
                                    class="profile-image-container profile-image-container-lg"
                                    [imageIdentifier]="person.imageIdentifier"
                                    [imageWidth]="100"
                                    (imageIdentifierChange)="updateProfileImageIdentifier(person, $event)"
                                    [defaultImageSrc]="defaultImageSrc"></adapt-select-image>
            </div>

            <div class="row justify-content-between align-items-center mb-3">
                <div class="form-group">
                    <label>First name</label>
                    <dx-text-box [(value)]="person.firstName"
                                 data-test="setup-profile-first-name">
                        <dx-validator>
                            <dxi-validator-validation-rule type="required"
                                                           message="Name is required"></dxi-validator-validation-rule>
                            <dxi-validator-validation-rule type="stringLength"
                                                           [min]="2"
                                                           message="Name must have at least 2 letters"></dxi-validator-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
                <div class="form-group">
                    <label>Last name</label>
                    <dx-text-box [(value)]="person.lastName"
                                 data-test="setup-profile-last-name">
                        <dx-validator>
                            <dxi-validator-validation-rule type="stringLength"
                                                           [min]="2"
                                                           message="Name must have at least 2 letters"></dxi-validator-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </div>
    }
</dx-validation-group>
